export default "__VITE_ASSET__B02w6fOF__"